module.exports = __webpack_public_path__ + "img/configuration.dc427af3.svg";